module.exports = __webpack_public_path__ + "img/search.26b2eb51.svg";